import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface DrawerState {
	drawerInfo?: {
		curso_id: number
		name_course: string
		description_course: string
		'type-course': string
		'company-is-image'?: boolean
		'size-company-drawer'?: {
			width: number
			height: number
		}
		company: string
		duration: number
		name_teacher: string
		foto_professor: string
		description_teacher: string
		about_course: string[]
		units: string[]
		turma?: {
			id: number
			curso_id: number
			empresa_id: number
			status: string
		}
	}
	opened: boolean
	disabledOnClose?: boolean
}

const initialState: DrawerState = {
	drawerInfo: undefined,
	opened: false,
	disabledOnClose: undefined,
}

export const drawerSlice = createSlice({
	name: 'drawer',
	initialState,
	reducers: {
		openDrawer: (
			state,
			{
				payload: { drawerInfo, disabledOnClose },
			}: PayloadAction<{
				drawerInfo: any
				disabledOnClose?: boolean
			}>
		) => {
			state.opened = true
			state.drawerInfo = drawerInfo
			state.disabledOnClose = disabledOnClose
		},
		closeDrawer: (state) => {
			state.drawerInfo = initialState.drawerInfo
			state.opened = initialState.opened
		},
		reset: () => initialState,
	},
})

export const drawerCreators = drawerSlice.actions

export const drawerReducer = drawerSlice.reducer
